import { useRef, useState } from 'react';
import { useClickedOutside } from './use-clicked-outside';

function useMenuState() {
  const [displayed, setDisplayed] = useState(false);
  const menuRef = useRef(null);
  useClickedOutside(menuRef, () => setDisplayed(false));
  return { displayed, setDisplayed, menuRef };
}

export { useMenuState };
